import Edward from "../../assets/aboutPage/team/edward.jpg";
import tayshaun from "../../assets/aboutPage/team/tayshaun.jpg";
import Chillin from "../../assets/aboutPage/team/chillen.jpg";
import fo from "../../assets/aboutPage/team/fo.jpg";
import angel from "../../assets/aboutPage/team/angel.jpg";
import einar from "../../assets/aboutPage/team/einar.jpg";
import edwin from "../../assets/aboutPage/team/edwin.jpg";

const innovationTeam = [
  {
    name: "Tayshaun Kelly",
    role: "Developer",
    img: tayshaun,
  },
  {
    name: "Fofang Atanga",
    role: "Developer",
    img: fo,
  },
  {
    name: "Edgar Chillin",
    role: "Developer",
    img: Chillin,
  },
  {
    name: "Edward Gonzalez",
    role: "Developer",
    img: Edward,
  },
  {
    name: "Edwin Aguilar",
    role: "Developer",
    img: edwin,
  },
  {
    name: "Einar Aguirre",
    role: "Developer",
    img: einar,
  },
  {
    name: "Angel Gomez",
    role: "Developer",
    img: angel,
  },
];

export default innovationTeam;
